module.exports = __webpack_public_path__ + "static/media/C20-0321_Bison_Mobile_767x845.ee2a1430.jpg";